import { I18nextProvider } from 'react-i18next';

import { i18n } from '#core/i18n/i18n.ts';

export function AppProvider({ children }: React.PropsWithChildren) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
